const PLUGIN_NAME = 'google-maps-fe';
const GOOGLE_MAPS_SCRIPT = 'https://maps.googleapis.com/maps/api/js?key=';
const COOPERATIVE = 'cooperative';
const NONE = 'none';
const LOAD = 'load';
const SCRIPT = 'script';
const ROADMAP = 'roadmap';
const SATELLITE = 'satellite';
const TERRAIN = 'terrain';
const MARKER = 'marker';
const POLYLINE = 'polyline';
const POLYGON = 'polygon';
const RECTANGLE = 'rectangle';
const CIRCLE = 'circle';
const DEFAULT_COLOR = '#FF0000';
const DEFAULT_OPTIONS = {
  strokeOpacity: 1.0,
  strokeWeight: 2
};
const FILL_OPTIONS = {
  fillOpacity: 0.35
};
const DISABLE_LABELS_STYLES = [{
  elementType: 'labels',
  stylers: [{
    visibility: 'off'
  }]
}];
const DISABLE_BOUNDARIES_STYLES = [{
  featureType: 'administrative',
  elementType: 'geometry',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'administrative.land_parcel',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'administrative.neighborhood',
  stylers: [{
    visibility: 'off'
  }]
}];
const DISABLE_POI_STYLES = [{
  featureType: 'poi',
  stylers: [{
    visibility: 'off'
  }]
}];
const DISABLE_TRANSPORTATION_STYLES = [{
  featureType: 'road',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  stylers: [{
    visibility: 'off'
  }]
}];
const ZOOM_CHANGED = 'zoom_changed';
const COLOR = 'Color';
const IMAGE_ID = 'imageId';
const URL = 'url';
const ID = 'id';
const CLICK = 'click';
const ELEMENT_GEOMETRY = 'geometry.fill';
const FEATURE_TYPE_MAP = {
  waterColor: 'water',
  landscapeColor: 'landscape'
};
const ALL = 'all';
const HEADING_LARGE = 'heading_large';
const LIST = 'list';
const IN_VIEW_CONFIG = {
  once: true,
  offset: '200px'
};
const DEFAULT_SELECT_VALUE = 'Default';
const DEFAULT_CUSTOM_MARKER_PATH = 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z';
export { PLUGIN_NAME, GOOGLE_MAPS_SCRIPT, COOPERATIVE, NONE, LOAD, SCRIPT, ROADMAP, SATELLITE, TERRAIN, MARKER, POLYLINE, POLYGON, RECTANGLE, CIRCLE, DEFAULT_OPTIONS, FILL_OPTIONS, DEFAULT_COLOR, ZOOM_CHANGED, COLOR, IMAGE_ID, URL, ID, CLICK, ELEMENT_GEOMETRY, FEATURE_TYPE_MAP, ALL, HEADING_LARGE, LIST, IN_VIEW_CONFIG, DISABLE_TRANSPORTATION_STYLES, DISABLE_POI_STYLES, DISABLE_BOUNDARIES_STYLES, DISABLE_LABELS_STYLES, DEFAULT_SELECT_VALUE, DEFAULT_CUSTOM_MARKER_PATH };
//# sourceMappingURL=constants.js.map